/* For inclusion in rewrites of apps to work with the 2025 rebrand styling. Replaces
 * core/core_third_party functionality, apps using new rebrand stuff should not load those bundles.
 *
 * NB: apps using this as a base do not get jQuery or underscore. If you are converting an existing
 * app to the rebrand styles & this base, you should also migrate that app away from jQuery &
 * dependency on window._.
 *
 * Migrating away from jQuery is largely about using the shared/api api client rather than `$.ajax`.
 * There may also be minor direct DOM interactions that should be converted to plain JS.
 *
 * Modules depending on `window._` should change to directly importing the underscore.js methods
 * they need like `import foo from "underscore/modules/foo.js"`, or switch to standard library
 * methods. We don't use much of underscore, this approach means the bundle only contains what
 * we use.
 *
 * Rebranded apps should also only use unredux/attachments, not shared/attachments.
 */

import * as Sentry from "@sentry/react"
import {initializeSentry} from "js/studios/shared/sentry"
import {listenForTrackEvents} from "js/studios/shared/tracking"
import {onPageReady} from "js/studios/shared/utils"
import {SimpleBox} from "@wfleming/simplebox"

initializeSentry(Sentry)

onPageReady(() => {
  listenForTrackEvents()
  // We do not provide captions/descriptions to show in the lightbox, and the default behavior would
  // pull from title/alt attrs which would show unhelpful text like "Expand image". So descriptions
  // are off: if we ever want to show image captions in lightbox we should probably use a `data`
  // attr & provide a `getDescription` fn to the config here.
  SimpleBox({selector: "[data-lightbox]", showDescription: false})

  // dismiss links on .django-messages rendered by studios_inc/django_messages_banner.html
  Array.from(document.querySelectorAll(".django-messages a[data-dismiss]")).forEach(a => {
    a.addEventListener("click", function (ev) {
      ev.preventDefault()
      const msg = document.getElementById(ev.target.dataset.dismiss)
      if (msg) { msg.remove() }
    })
  })
})
